import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPackageOpened = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M2.5 3.5625L10 4.4375L17.4688 3.5625C17.9062 3.5 18.3438 3.75 18.5 4.15625L19.5 6.5C19.8125 7.21875 19.4062 8.03125 18.625 8.21875L13.6563 9.34375C13.0625 9.5 12.4688 9.25 12.0938 8.75L10 5.78125L7.875 8.75C7.5 9.25 6.90625 9.5 6.3125 9.34375L1.34375 8.1875C0.5625 8.03125 0.15625 7.21875 0.46875 6.5L1.46875 4.15625C1.625 3.75 2.0625 3.5 2.5 3.5625ZM2.375 4.5625L1.375 6.875C1.3125 7.03125 1.40625 7.1875 1.5625 7.21875L6.53125 8.375C6.71875 8.4375 6.9375 8.34375 7.0625 8.1875L9.09375 5.34375L2.375 4.5625ZM17 9.40625L18 9.125L18 13.8437C18 14.5312 17.5313 15.125 16.8438 15.3125L10.3438 16.9375C10.125 17 9.875 17 9.625 16.9375L3.125 15.3125C2.46875 15.125 2 14.5312 2 13.8438L2 9.125L3 9.40625L3 13.8438C3 14.0625 3.15625 14.2812 3.375 14.3125L9.5 15.8437V8.5C9.5 8.25 9.71875 8 10 8C10.25 8 10.5 8.25 10.5 8.5V15.8437L16.5938 14.3125C16.8438 14.2812 17 14.0625 17 13.8437L17 9.40625ZM10.875 5.34375L12.9063 8.1875C13.0313 8.34375 13.25 8.40625 13.4375 8.375L18.4062 7.21875C18.5625 7.1875 18.6562 7.03125 18.5938 6.875L17.5938 4.5625L10.875 5.34375Z"
	})
});
const ForwardRef = forwardRef(SvgPackageOpened);
export default ForwardRef;
